module.exports = __webpack_public_path__ + "static/media/trivia-add.77ed4e92.png";